import EventTypeDTO from "./EventTypeDTO";

export default class EventDTO {

  public id?: number;
  public type?: EventTypeDTO;
  public newDate?: Date;
  public newStage?: string;
  public processDate?: Date;
  public processStage?: string;
  public timezone?: string;
  public link?: string;
  public description?: string;
  public eventLanguage?: string;
  public createdBy?: string;
  public updatedBy?: string;
  public agenda?: string;
  public extraInfo?: string;

  // constructor(type: EventTypeDTO, date: string, stage: string, timezone: string, link: string, description: string, eventLanguage: string, id?: number) {
  //   this.type = type;
  //   this.date = date;
  //   this.stage = stage;
  //   this.timezone = timezone;
  //   this.link = link;
  //   this.description = description;
  //   this.eventLanguage = eventLanguage;
  // }

}
